module.exports = __webpack_public_path__ + "assets/img/block-left-hover-7b1e725e.png";